'use client';

import { Separator, SidebarTrigger, useSidebar } from '@repo/ui';
import type { JSX } from 'react';
import { BreadcrumbWrapper } from './_breadcrumb/breadcrumb-wrapper';
import { useHeaderActions } from './_header-actions';

export function DashboardLayoutHeader(): JSX.Element {
  const { state, isMobile } = useSidebar();
  const shouldShowTrigger = isMobile || state === 'collapsed';
  const { actions } = useHeaderActions();

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear select-none">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        {shouldShowTrigger && (
          <>
            <SidebarTrigger className="-ml-1 text-foreground" />
            <Separator orientation="vertical" className="mx-2 data-[orientation=vertical]:h-4" />
          </>
        )}
        <BreadcrumbWrapper />
        {actions && <div className="ml-auto flex items-center gap-3">{actions}</div>}
      </div>
    </header>
  );
}
